import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { Component, Input, OnInit } from '@angular/core';

import { PageSectionContent } from '@types';
import { SectionComponent } from '../section-component.interface';

@Component({
  selector: 'ft-intro-section',
  templateUrl: './intro-section.component.html',
})
export class IntroSectionComponent implements OnInit, SectionComponent {
  /**
   * Bloomreach component
   */
  component: BrComponent;

  /**
   * Bloomreach page model
   */
  page: Page;

  /**
   * Page Section content
   */
  @Input() content: PageSectionContent;

  /**
   * Display type
   */
  sectionType: string;

  /**
   * Show CTA
   */
  @Input() showCta = false;

  /**
   * Show Content
   */
  @Input() showContent = true;

  constructor() {}

  /**
   * Populate the component
   * @param component - A parameter
   * @param page - A parameter
   * @param content - A parameter
   */
  populate(
    component: BrComponent,
    page: Page,
    sectionType: string,
    content: PageSectionContent,
    theme: string
  ) {
    this.component = component;
    this.page = page;
    this.sectionType = sectionType;
    this.content = content;
    this.showCta = false;
  }

  ngOnInit(): void {}
}
